// extracted by mini-css-extract-plugin
export default {"Highlight":"HighlightText__Highlight__c2kVN"};